import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BtnModalTable,
  BtnOutlineGreen,
  BtnOutlineRed,
} from '../../../styled-components';
import {
  Col,
  CustomInput,
  Form,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import Autosuggest from '../../../commons/Autosuggest';
import DateInput from '../../../commons/DateInput';
import moment from 'moment';
import axios from 'axios';
import { useAuth } from '../../../commons/Auth';

const EditClaimModal = ({
  data: claim = {},
  searchSuppliers,
  onConfirm,
  profile,
  events = [],
}) => {
  const [t] = useTranslation('CLAIMS');
  const [modal, setModal] = useState(false);
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  const [listStatus, setListStatus] = useState([
    { value: 'SETTLED', label: 'Liquidato' },
    { value: 'CLOSED', label: 'Chiuso senza seguito' },
  ]);

  const getInitialFormState = () => ({
    insurance: {
      _id: claim.insurance?._id || '',
      policy_code: claim.insurance?.policy_code || '',
    },
    claimNumber: claim.claimNumber || '',
    start_date: claim.start_date || '',
    event: claim.event?._id || '',
    expert: claim.expert || '',
    reserve: claim.reserve || 0,
    status: claim.status === 'CHECK' ? '' : claim.status || '',
    liquidator: claim.liquidator || '',
    notes: claim.notes || '',
    paid_amount: claim.paid_amount || 0,
    date_paid: claim.date_paid || '',
    appointedSupplier: {
      _id: claim.appointedSupplier?._id || '',
      businessName: claim.appointedSupplier?.businessName || '',
    },
    intern: claim.intern !== null ? claim.intern : true,
  });
  const [formValues, setFormValues] = useState(getInitialFormState());
  const [formErrors, setFormErrors] = useState({
    insurance: false,
    claimNumber: false,
    start_date: false,
    event: false,
    expert: false,
    reserve: false,
  });

  const toggle = () => {
    setModal(!modal);
    setFormValues(getInitialFormState());
  };

  function onInputChange({ target }) {
    setFormValues((state) => ({ ...state, [target.name]: target.value }));
  }

  function onNumericInputChange({ target }) {
    if (/^-?[\d]*\.?[\d]{0,2}$/.test(target.value)) {
      setFormValues((state) => ({
        ...state,
        [target.name]: target.value,
      }));
    }
  }

  const renderInsuranceSuggestion = ({ policy_code = '' }) => policy_code;
  const getInsuranceSuggestionValue = ({ policy_code = '' }) => policy_code;
  function onInsuranceSuggestionSelect({ _id, policy_code }) {
    setFormValues((state) => ({
      ...state,
      insurance: { _id: _id, policy_code },
    }));
  }

  const renderSupplierSuggestion = ({ businessName = '' }) => businessName;
  const getSupplierSuggestionValue = ({ businessName = '' }) => businessName;
  function onSupplierSuggestionSelect({ _id, businessName }) {
    setFormValues((state) => ({
      ...state,
      appointedSupplier: { _id: _id, businessName },
    }));
  }

  const onSelectEvent = (selectedEventId) => {
    if (selectedEventId === '') {
      setFormValues((state) => ({
        ...state,
        event: '',
      }));
      formErrors.event = true;
      return;
    }

    formErrors.event = false;
    const selectedEvent = events.filter(
      (event) => event._id === selectedEventId
    )[0];

    setFormValues((state) => ({
      ...state,
      event: selectedEvent._id,
    }));
  };

  const onSelectStatus = (selectedStatus) => {
    if (selectedStatus === '') {
      setFormValues((state) => ({
        ...state,
        status: '',
      }));
      formErrors.status = true;
      return;
    }

    formErrors.status = false;

    setFormValues((state) => ({
      ...state,
      status: selectedStatus,
    }));
  };

  const onEditClaimConfirm = () => {
    const {
      insurance,
      claimNumber,
      start_date,
      event,
      expert,
      reserve,
      notes,
      status,
      liquidator,
      paid_amount,
      date_paid,
      appointedSupplier,
      intern,
    } = formValues;

    const errors = {};

    if (!insurance || insurance === '') errors.insurance = true;
    if (!claimNumber) errors.claimNumber = true;
    if (!start_date) errors.start_date = true;
    if (!event) errors.event = true;
    if (!expert) errors.expert = true;
    if (!reserve) errors.reserve = true;
    if (!status) errors.status = true;
    if (!liquidator) errors.liquidator = true;
    if (!paid_amount) errors.paid_amount = true;
    if (!date_paid) errors.date_paid = true;
    if (
      intern === true &&
      (!appointedSupplier._id || appointedSupplier._id === '')
    ) {
      errors.appointedSupplier = true;
    }

    if (Object.keys(errors).length) {
      return setFormErrors(errors);
    }

    onConfirm({
      ...formValues,
      _id: claim._id,
      insurance: formValues.insurance._id,
      reserve: parseFloat(formValues.reserve),
      paid_amount: parseFloat(formValues.paid_amount),
    });

    toggle();
  };

  function listenForEscapeEvent() {
    document.addEventListener('keydown', ({ key }) => {
      if (key === 'Escape') toggle();
    });
  }

  const {
    insurance,
    claimNumber,
    start_date,
    event,
    expert,
    reserve,
    notes,
    status,
    liquidator,
    paid_amount,
    date_paid,
    appointedSupplier,
    intern,
  } = formValues;

  //Per suggest nella modale di creazione claims
  const searchInsurances = async (value) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/insurances/admin/claims/${profile._id}`,
      {
        headers: { Authorization: newToken },
        params: { policy_code: value, dateForClaims: start_date },
      }
    );

    if (response instanceof Error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return [];
    }

    const { data = [] } = response;
    return data;
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ marginLeft: '10px' }}>
          <BtnModalTable type="button" onClick={toggle}>
            MODIFICA
          </BtnModalTable>
        </div>
      </div>

      <Modal
        isOpen={modal}
        className="new-invoice-modal"
        onOpened={listenForEscapeEvent}
        style={{ maxWidth: '80%' }}
      >
        <ModalHeader toggle={toggle}>{t('EDIT_CLAIM')}</ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onEditClaimConfirm(formValues);
          }}
        >
          <ModalBody>
            <Row>
              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('CLAIM_DATE')} *</Label>
                  <DateInput
                    name="start_date"
                    value={start_date}
                    onChange={(start_date) => {
                      const utcDate = moment
                        .utc(moment(start_date).format('YYYY-MM-DD'))
                        .startOf('day')
                        .toDate();
                      setFormValues((state) => ({
                        ...state,
                        start_date: utcDate,
                        insurance: { _id: '', policy_code: '' },
                      }));
                    }}
                  />
                  {formErrors.start_date && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('INSURANCE_POLICY_CODE')} *</Label>
                  <Autosuggest
                    placeholder="Cerca un assicurazione..."
                    onFetch={searchInsurances}
                    onSelect={onInsuranceSuggestionSelect}
                    renderSuggestion={renderInsuranceSuggestion}
                    getSuggestionValue={getInsuranceSuggestionValue}
                    value={insurance.policy_code}
                    disabled={!start_date}
                    onChange={(policy_code) => {
                      if (policy_code === '') {
                        setFormValues((state) => ({
                          ...state,
                          insurance: { _id: '', policy_code: '' },
                          claimNumber: '',
                          event: '',
                          expert: '',
                          reserve: 0,
                          notes: '',
                        }));
                      } else {
                        setFormValues((state) => ({
                          ...state,
                          insurance: { ...insurance, policy_code },
                        }));
                      }
                    }}
                  />
                  {formErrors.insurance && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('CLAIM_NUMBER')} *</Label>
                  <Input
                    type="text"
                    name="claimNumber"
                    value={claimNumber}
                    onChange={onInputChange}
                  />
                  {formErrors.claimNumber && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('EXPERT')} *</Label>
                  <Input
                    type="text"
                    name="expert"
                    value={expert}
                    onChange={onInputChange}
                  />
                  {formErrors.expert && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('RESERVE')} *</Label>
                  <InputGroup>
                    <Input
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      name="reserve"
                      value={reserve}
                      onChange={onNumericInputChange}
                    />
                    <InputGroupAddon addonType="prepend">€</InputGroupAddon>
                  </InputGroup>
                  {formErrors.reserve && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('EVENT')} *</Label>
                  <CustomInput
                    type="select"
                    id="type"
                    name="event"
                    onChange={(e) => onSelectEvent(e.target.value)}
                    value={event}
                  >
                    <option value="">{t('SELECT_EVENT')}</option>
                    {events.length > 0 &&
                      events?.map((event) => (
                        <option key={event._id} value={event._id}>
                          {`${event.name}`}
                        </option>
                      ))}
                  </CustomInput>
                  {formErrors.event && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('LIQUIDATOR')} *</Label>
                  <Input
                    type="text"
                    name="liquidator"
                    value={liquidator}
                    onChange={onInputChange}
                  />
                  {formErrors.liquidator && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('DATE_PAID')} *</Label>
                  <DateInput
                    name="date_paid"
                    value={date_paid}
                    onChange={(date_paid) => {
                      const utcDate = moment
                        .utc(moment(date_paid).format('YYYY-MM-DD'))
                        .startOf('day')
                        .toDate();
                      setFormValues((state) => ({
                        ...state,
                        date_paid: utcDate,
                      }));
                    }}
                  />
                  {formErrors.date_paid && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('PAID_AMOUNT')} *</Label>
                  <InputGroup>
                    <Input
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      name="paid_amount"
                      value={paid_amount}
                      onChange={onNumericInputChange}
                    />
                    <InputGroupAddon addonType="prepend">€</InputGroupAddon>
                  </InputGroup>
                  {formErrors.paid_amount && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('STATUS')} *</Label>
                  <CustomInput
                    type="select"
                    id="type"
                    name="status"
                    onChange={(e) => onSelectStatus(e.target.value)}
                    value={status}
                  >
                    <option value="">{t('SELECT_STATUS')}</option>
                    {listStatus?.map((status) => (
                      <option key={status.value} value={status.value}>
                        {`${status.label}`}
                      </option>
                    ))}
                  </CustomInput>
                  {formErrors.status && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col sm="12" md="6">
                <FormGroup>
                  <Label>{t('SUPPLIER_INTERN')}</Label>
                  <div>
                    <CustomInput
                      type="radio"
                      id="internRadio1"
                      label="SI"
                      name="intern"
                      value="1"
                      inline
                      checked={intern}
                      onChange={() =>
                        setFormValues((state) => ({
                          ...state,
                          intern: true,
                        }))
                      }
                    />
                    <CustomInput
                      type="radio"
                      id="internRadio2"
                      label="NO"
                      name="intern"
                      value="0"
                      inline
                      checked={!intern}
                      onChange={() =>
                        setFormValues((state) => ({
                          ...state,
                          appointedSupplier: { _id: '', businessName: '' },
                          intern: false,
                        }))
                      }
                    />
                  </div>
                </FormGroup>
              </Col>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label>{t('APPOINTED_SUPPLIER')} *</Label>
                  <Autosuggest
                    placeholder="Cerca un fornitore..."
                    onFetch={searchSuppliers}
                    onSelect={onSupplierSuggestionSelect}
                    renderSuggestion={renderSupplierSuggestion}
                    getSuggestionValue={getSupplierSuggestionValue}
                    value={
                      intern == true
                        ? appointedSupplier.businessName
                        : 'Altro (fornitore esterno)'
                    }
                    disabled={intern == false}
                    onChange={(businessName) => {
                      if (businessName === '') {
                        setFormValues((state) => ({
                          ...state,
                          appointedSupplier: { _id: '', businessName: '' },
                        }));
                      } else if (businessName === 'Altro (fornitore esterno)') {
                        setFormValues((state) => ({
                          ...state,
                          appointedSupplier: { _id: '', businessName: '' },
                        }));
                      } else {
                        setFormValues((state) => ({
                          ...state,
                          appointedSupplier: {
                            ...appointedSupplier,
                            businessName,
                          },
                        }));
                      }
                    }}
                  />
                  {formErrors.appointedSupplier && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col xs="12">
                <FormGroup>
                  <Label>{t('NOTES')}</Label>
                  <Input
                    type="textarea"
                    name="notes"
                    value={notes}
                    onChange={onInputChange}
                    rows="4"
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
};

export default EditClaimModal;
